import * as React from 'react';
var a ='test'
import * as ReactDOM from 'react-dom';
import Storage from  './storage'
import { Provider } from 'react-redux';
import Container from "./components/Container";
import startBlock from "./components/StartBlock";



window.Storage = Storage;

export class App extends React.Component {
	state = {};

	constructor(props) {
		super(props);
	}

	render() {
		return (
		<h1>test</h1>
		)
	}
}


if (document.getElementById('static-gloop-container')) {
	ReactDOM.render(
		<Provider store={Storage}>
			<Container/>
		</Provider>
		,
		document.getElementById('static-gloop-container')
	);
}else{
	ReactDOM.render(
	<Provider store={Storage}>
		<Container/>
	</Provider>
	,
    document.getElementById('gloop_app')
);
}





String.prototype.capitalize = function() {
    return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
};

if(window.location.hash && window.location.hash.indexOf('#editor')!=-1){
	let parts = window.location.hash.replace('#editor','');
	window.editorProductActivate(window.PostID+parts);
}

//window.activateGloop(1073);
